import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import UserListSection from './section-components/user-list';
import Footer from './global-components/footer';
import BlogContact from '../utils/blogContact';

const UserList = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="User List" />
        <UserListSection />
        <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
        <Footer />
    </div>
}

export default UserList

